// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import {getFirestore} from "@firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBY-19q4XV8O30SkhbPLfPYSqXLCNVl7xk",
  authDomain: "spoura-5a69f.firebaseapp.com",
  projectId: "spoura-5a69f",
  storageBucket: "spoura-5a69f.appspot.com",
  messagingSenderId: "157370872385",
  appId: "1:157370872385:web:b95138f64b88ad47f94cc0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const firestore = getFirestore(app);